import { render, staticRenderFns } from "./ArticleBasic.vue?vue&type=template&id=9a37311e&scoped=true"
import script from "./ArticleBasic.vue?vue&type=script&lang=js"
export * from "./ArticleBasic.vue?vue&type=script&lang=js"
import style0 from "./ArticleBasic.vue?vue&type=style&index=0&id=9a37311e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a37311e",
  null
  
)

export default component.exports